"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var GwsGameProviderEditor = /** @class */ (function (_super) {
    __extends(GwsGameProviderEditor, _super);
    function GwsGameProviderEditor(props) {
        return _super.call(this, props) || this;
    }
    GwsGameProviderEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.recordKey != null) {
            var _item = this.props.data.getById(this.props.recordKey.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    description: _item.description,
                    is_deprecated: _item.is_deprecated,
                    is_locked: _item.is_locked,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование шлюза"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                is_deprecated: false,
                is_locked: false,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание шлюза"]);
            });
        }
        this.doReSetRules();
    };
    GwsGameProviderEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
        });
    };
    GwsGameProviderEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        return true;
    };
    GwsGameProviderEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.recordKey.key,
                description: this.state.description,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Геймпровайдер изменен!");
            });
        }
    };
    GwsGameProviderEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Геймпровайдер создан!");
            });
        }
    };
    GwsGameProviderEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    GwsGameProviderEditor.prototype.getFormTitle = function () {
        if (this.props.recordKey == null) {
            return "Новый геймпровайдер";
        }
        else {
            return "Изменить геймпровайдера";
        }
    };
    GwsGameProviderEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устаревший геймпровайдер", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокированный геймпровайдер", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.recordKey != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return GwsGameProviderEditor;
}(React.Component));
exports.default = GwsGameProviderEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ui/component/GwsGameProvidersEditor.tsx
// module id = 1856
// module chunks = 0